import React, { FC } from 'react';
import { Box, Divider, Paper, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Capability } from 'components';

import GroupSwitch from './GroupSwitch';
import ModerationType from './ModerationType';
import theme from 'theme';

const styles = {
  paper: {
    padding: theme.spacing(2, 3, 3.5, 2),
  },
} as const;

const GroupSettings: FC = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={styles.paper}>
      <Grid container spacing={3} paddingTop={2} paddingLeft={2}>
        <Grid xs={12} sm={3}>
          <Typography variant="subtitle2">{t('admin:settings')}</Typography>
        </Grid>

        <Grid xs container alignItems="center" spacing={2}>
          <Grid xs={12}>
            <ModerationType />
          </Grid>

          <Grid xs={12} paddingTop={2}>
            <Divider />
          </Grid>

          <Grid xs={12}>
            <GroupSwitch
              value="allow_user_posts"
              title={t('groups:allowMemberPost')}
              description={t('groups:allowMemberPostDesc')}
            />

            <Box paddingTop={2}>
              <Divider />
            </Box>
          </Grid>

          <Grid xs={12}>
            <GroupSwitch
              value="read_only"
              title={t('groups:readOnly')}
              description={t('groups:readOnlyDesc')}
            />
          </Grid>

          <Grid xs={12}>
            <Capability name="Group.Function.PrivateGroups">
              <Box paddingBottom={2}>
                <Divider />
              </Box>

              <GroupSwitch
                value="is_private"
                title={t('groups:privateGroup')}
                description={t('groups:privateGroupDesc')}
              />
            </Capability>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GroupSettings;
